
export const balatroPresets = {
  classic: {
    color1: "#DE443B",
    color2: "#006BB4", 
    color3: "#162325",
    contrast: 3.5,
    lighting: 0.4,
    spinAmount: 0.25,
    pixelFilter: 2500.0,
    spinRotation: 0.2,
    spinSpeed: 6.0,
    isRotate: true,
    mouseInteraction: false
  },

  fire: {
    color1: "#FF4500",
    color2: "#FF8C00",
    color3: "#8B0000",
    contrast: 4.0,
    lighting: 0.6,
    spinAmount: 0.4,
    pixelFilter: 600.0,
    spinRotation: -3.0,
    spinSpeed: 9.0,
    isRotate: true,
    mouseInteraction: true
  },

  ocean: {
    color1: "#00CED1",
    color2: "#4682B4",
    color3: "#191970",
    contrast: 3.0,
    lighting: 0.3,
    spinAmount: 0.15,
    pixelFilter: 800.0,
    spinRotation: 1.5,
    spinSpeed: 5.0,
    isRotate: false,
    mouseInteraction: true
  },

  magic: {
    color1: "#8A2BE2",
    color2: "#4B0082",
    color3: "#2F0E4B",
    contrast: 4.5,
    lighting: 0.5,
    spinAmount: 0.35,
    pixelFilter: 650.0,
    spinRotation: -2.5,
    spinSpeed: 8.0,
    isRotate: false,
    mouseInteraction: true
  },

  gold: {
    color1: "#FFD700",
    color2: "#FFA500",
    color3: "#8B4513",
    contrast: 3.8,
    lighting: 0.7,
    spinAmount: 0.2,
    pixelFilter: 900.0,
    spinRotation: -1.0,
    spinSpeed: 4.0,
    isRotate: false,
    mouseInteraction: true
  },

  minimal: {
    color1: "#FFFFFF",
    color2: "#808080",
    color3: "#000000",
    contrast: 2.0,
    lighting: 0.1,
    spinAmount: 0.1,
    pixelFilter: 1000.0,
    spinRotation: -0.5,
    spinSpeed: 2.0,
    isRotate: false,
    mouseInteraction: false
  },

  cyberpunk: {
    color1: "#00FFFF",
    color2: "#FF00FF",
    color3: "#0D0D0D",
    contrast: 5.0,
    lighting: 0.8,
    spinAmount: 0.5,
    pixelFilter: 500.0,
    spinRotation: -4.0,
    spinSpeed: 12.0,
    isRotate: true,
    mouseInteraction: true
  },

  nature: {
    color1: "#32CD32",
    color2: "#228B22",
    color3: "#006400",
    contrast: 2.8,
    lighting: 0.35,
    spinAmount: 0.18,
    pixelFilter: 850.0,
    spinRotation: 1.0,
    spinSpeed: 3.5,
    isRotate: false,
    mouseInteraction: true
  }
};
